import React from "react"
import { Link, graphql, useScrollRestoration } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import CustomSections from "../components/custom-sections"
import Hero from "../components/hero"
import StickyMenu, { hasStickyMenu } from "../components/sticky-menu"
import MainContent from "../components/main-content"
import Share from "../components/share"
import Print from "../components/print"
import AnnualReport from "../components/annual-report"
import { FaChevronLeft } from "react-icons/fa"
import { Helmet } from "react-helmet"
// import MyTweet from "../components/tweet"

const PageTemplate = ({ location, data }) => {
  const page = data.wpPage
  const sections = page.customSections?.customsections
  let annualReport;
  switch (page.customSections?.layout) {
    case "annualReport":
      annualReport = "2022";
      break;
    case "annualReport2023":
      annualReport = "2023";
      break;
    case "annualReport2024":
      annualReport = "2024";
      break;
    default:
      annualReport = false;
  }
  const placeMainContent = sections?.some(section => section.fieldGroupName?.includes("MainContent"))
  const ulScrollRestoration = useScrollRestoration(`page-component-ul-list`)
  const hasMenu = hasStickyMenu(sections)

  return (
    <div  {...ulScrollRestoration} className={annualReport === "2023" ? "annual-report-2023" : ""}>
      <Layout isHomePage annualReport={annualReport} location={location} hasMenu={hasMenu}>
        <Seo
          title={page.seo?.title || page.title}
          description={page.seo?.metaDesc || ""}
          image={page.seo?.opengraphImage?.localFile?.publicURL}
        />
        {annualReport ? <AnnualReport /> : null}
        {annualReport === "2024" ?

          <Helmet>
            <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet" />
          </Helmet> : null}

        <Hero
          hero={page.hero}
          title={page.title}
          featuredImage={page.featuredImage}
          annualReport={annualReport}
        />

        {hasMenu && annualReport !== "2024" ? <StickyMenu sections={sections} /> : null}

        {!placeMainContent ? <MainContent content={page.content} /> : null}

        {sections ? (
          <CustomSections sections={sections} content={page.content} annualReport={annualReport} location={location} />
        ) : null}

        {annualReport ? 

        <section className={`${annualReport === "2024" ? "p-section bg-cover bg-circles-only-blue px-8 text-center": "container mt-10"} `}><Link to="/" className={`btn ${annualReport === "2024" ? "btn-white" : " btn-green"}`}><FaChevronLeft className="mr-1" />Back to main PAGE site</Link></section> 
        
        : null}

        <Print />

        <Share props={page} />

        {/* <MyTweet /> */}
      </Layout>
    </div>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query PageById($id: String!) {
    wpPage(id: { eq: $id }) {
      customSections {
        layout
        customsections {
          ... on WpPage_Customsections_Customsections_BasicContentBlock {
            content
            contentWidth
            leadContent
            heading
            fieldGroupName
            button {
              target
              title
              url
            }
            background
            linkList {
              link {
                target
                title
                url
              }
            }
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_AltImgText {
            content
            fieldGroupName
            heading
            image {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                extension
                publicURL
              }
              caption
            }
            imageCrop
            imagePosition
            imageBackgroundColor
            backgroundColorAr
            modalContent
            button {
              target
              title
              url
            }
            buttonText
            disableAnimation
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_Highlights {
            format
            backgroundColor
            backgroundColorAr
            columnCount
            heading
            leadContent
            leadContentSize
            fieldGroupName
            highlights {
              icon {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  extension
                  publicURL
                }
              }
              button {
                target
                title
                url
              }
              buttonText
              content
              heading
              modalContent
              expandedContent
              iconFit
            }
            modalOrExpandable
            leadContent
            includeIcons
            iconSize
            iconBackgroundColor
            includeInStickyMenu {
              menuTitle
              includeSection
            }
          }
          ... on WpPage_Customsections_Customsections_MainContent {
            fieldGroupName
            classes
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_PageByNumbers {
            fieldGroupName
            backgroundColor
            heading
            leadContent
            pbnNumbers {
              fieldGroupName
              pageByNumbersCustomListing {
                fieldGroupName
                link {
                  target
                  title
                  url
                }
                number
                numberAppend
                numberDescription
                numberContent
                numberPrepend
                icon {
                  altText
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    extension
                    publicURL
                  }
                }
              }
            }
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_Video {
            fieldGroupName
            heading
            videoLink
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_Quote {
            citation
            citationDescription
            citationUrl
            fieldGroupName
            image {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            quote
            additionalQuotes {
              citation
              citationDescription
              citationUrl
              quote
              image {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
            backgroundColor
            backgroundColorAr24
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_Milestones {
            fieldGroupName
            heading
            year {
              milestones
              year
              link {
                target
                title
                url
              }
            }
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_Expandablegroups {
            fieldGroupName
            heading
            leadContent
            image {
              altText
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            includeInStickyMenu {
              includeSection
              menuTitle
            }
            groups {
              backgroundColor
              expandableBlock {
                expandedContent
                heading
                content
                format
              }
              heading
              leadContent
              icon {
                altText
                localFile {
                  publicURL
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
            backgroundColorAr
            columnCount
          }
          ... on WpPage_Customsections_Customsections_Gallery {
            fieldGroupName
            images {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          ... on WpPage_Customsections_Customsections_CountryGroup {
            fieldGroupName
            heading
            includeInStickyMenu {
              includeSection
              menuTitle
            }
            countries {
              ... on WpCountry {
                ...CountryCard
              }
            }
            leadContent
          }
          ... on WpPage_Customsections_Customsections_IconList {
            heading
            includeInStickyMenu {
              includeSection
              menuTitle
            }
            fieldGroupName
            icons {
              icon {
                altText
                localFile {
                  publicURL
                  childImageSharp {
                    gatsbyImageData
                  }
                  extension
                }
              }
              label
              link {
                target
                title
                url
              }
            }
            leadContent
            iconListOptions {
              iconSize
              yearList
              cropIcon
            }
          }
          ... on WpPage_Customsections_Customsections_PieChart {
            content
            fieldGroupName
            heading
            includeInStickyMenu {
              includeSection
              menuTitle
            }
            leadContent
            contentWidth
            data {
              label
              value
              backgroundColor
              hoverBackgroundColor
            }
            prependValues
            appendValues
            chartType
          }
          ... on WpPage_Customsections_Customsections_OutcomesAllCountries {
            fieldGroupName
            heading
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_NewsArchive {
            fieldGroupName
            heading
            includeInStickyMenu {
              includeSection
              menuTitle
            }
            type
            link {
              target
              title
              url
            }
          }
          ... on WpPage_Customsections_Customsections_EventsArchive {
            fieldGroupName
            heading
            includeInStickyMenu {
              includeSection
              menuTitle
            }
            type
            link {
              target
              title
              url
            }
          }
          ... on WpPage_Customsections_Customsections_PostHighlights {
            fieldGroupName
            heading
            primaryLink {
              target
              title
              url
            }
            secondaryLink {
              target
              title
              url
            }
            type
            limit
            posts {
              ... on WpPost {
                ...NewsCard
              }
              ... on WpEvent {
                ...EventCard
              }
            }
            category {
              events {
                nodes {
                  ...EventCard
                }
              }
              posts {
                nodes {
                  ...NewsCard
                }
              }
            }
            includeInStickyMenu {
              includeSection
              menuTitle
            }
          }
          ... on WpPage_Customsections_Customsections_KnowledgeHubArchive {
            fieldGroupName
            type
            heading
            articles {
              ... on WpKnowledgeHubArticle {
                ...KnowledgeHubArticle
              }
            }
            link {
              target
              title
              url
            }
            includeInStickyMenu {
              menuTitle
              includeSection
            }
          }
          ... on WpPage_Customsections_Customsections_InternalResources {
            fieldGroupName
            heading
            includeInStickyMenu {
              menuTitle
              includeSection
            }
          }
          ... on WpPage_Customsections_Customsections_Infographic {
            fieldGroupName
            heading
            leadContent
            infographicItem {
              heading
              subheading
              modal
              icon {
                altText
                localFile {
                  publicURL
                }
              }
            }
            includeInStickyMenu {
              menuTitle
              includeSection
            }
          }
        }
      }
      title
      uri
      content
      # shareOptions {
      #   shareTextOverride
      # }
      hero {
        mainHeading
        smallHeading
        button {
          target
          title
          url
        }
        imagePosition
        image {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1980, quality: 90)
            }
          }
        }
        video {
          localFile {
            extension
          }
          mediaItemUrl
          title
        }
        imageOverlay
        height
        backgroundColor
        # TO-DO: remove WP disabled label for backgroundColor
      }
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1980, quality: 90)
            }
          }
        }
      }
      seo {
        title
        metaDesc
        opengraphImage {
          localFile {
            publicURL
          }
        }
      }
    }
  }
`
